'use strict';

const TOKEN_KEY = 'labcodeStaffJwt';
const PROFILE_KEY = 'labcodeStaffProfile';
/** @type {readonly [string, string]} */
const STUDENT_KEYS = ['labcodeStudentJwt', 'labcodeStudentProfile'];

function getStorage () {
    if (typeof sessionStorage === 'undefined') return null;
    return sessionStorage;
}

function clearStudentKeys (st) {
    if (!st) return;
    try {
        for (const k of STUDENT_KEYS) {
            st.removeItem(k);
        }
    } catch (e) {
        // ignore
    }
}

/**
 * @returns {string|null}
 */
export function getLabcodeStaffToken () {
    const st = getStorage();
    if (!st) return null;
    try {
        return st.getItem(TOKEN_KEY);
    } catch (e) {
        return null;
    }
}

/**
 * @returns {object|null}
 */
export function getLabcodeStaffProfile () {
    const st = getStorage();
    if (!st) return null;
    try {
        const raw = st.getItem(PROFILE_KEY);
        if (!raw) return null;
        return JSON.parse(raw);
    } catch (e) {
        return null;
    }
}

export function hasLabcodeStaffSession () {
    return Boolean(getLabcodeStaffToken());
}

/**
 * @param {string} token
 * @param {object} staff
 */
export function setLabcodeStaffSession (token, staff) {
    const st = getStorage();
    if (!st) return false;
    clearStudentKeys(st);
    try {
        st.setItem(TOKEN_KEY, token);
        st.setItem(PROFILE_KEY, JSON.stringify(staff || {}));
    } catch (e) {
        return false;
    }
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(new CustomEvent('labcode-staff-session-changed'));
    }
    return true;
}

export function clearLabcodeStaffSession () {
    const st = getStorage();
    if (!st) return;
    try {
        st.removeItem(TOKEN_KEY);
        st.removeItem(PROFILE_KEY);
    } catch (e) {
        // ignore
    }
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(new CustomEvent('labcode-staff-session-changed'));
    }
}
